import { getUsers } from 'common/api/companies';

import {
    FETCH_USERS,
    FETCH_USERS_FAILURE,
    FETCH_USERS_SUCCESS,
} from '../actionTypes';
import { companyUsersActions } from '../reducer';

export default (id, filterData) => (dispatch) => {
    dispatch(companyUsersActions[FETCH_USERS]());

    const { page, orderBy, sortBy, searchText } = filterData;

    getUsers(id, page + 1, orderBy, sortBy, searchText)
        .then((response) =>
            dispatch(companyUsersActions[FETCH_USERS_SUCCESS](response.data)),
        )
        .catch((error) =>
            dispatch(
                companyUsersActions[FETCH_USERS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
